/* import __COLOCATED_TEMPLATE__ from './categories-and-top-topics.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./categories-and-top-topics.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  classNames: ["categories-and-top"]
}));